import jspdf from 'jspdf';

export default {
    name: "ExportChart",

    methods: {
        downloadPDF() {
            let name = 'chart';
            let canvas = this.$refs.canvas;

            const canvasImg = canvas.toDataURL("image/png", 1.0);

            //creates PDF from img
            const doc = new jspdf('landscape');
            //doc.setFontSize(20);
            //doc.text(15, 15, "Cool Chart");
            doc.addImage(canvasImg, 'JPEG', 10, 10, 280, 150);
            doc.save(name + '.pdf');
        }
    }
}
